module.exports = __webpack_public_path__ + "static/img/certificate_img19.3bcd4af3.jpg";